import clsx from 'clsx';
import { FC } from 'react';
import { useLayout } from '../core/LayoutProvider';

type Props = {
  title?: string;
  icon?: string;
};

const Toolbar: FC<Props> = ({ title, icon, children }) => {
  const { classes } = useLayout();

  return (
    <div className='toolbar' id='kt_toolbar'>
      <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
        <div id='kt_page_title' data-kt-swapper='true' data-kt-swapper-mode='prepend' data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className={clsx('page-title d-flex', classes.pageTitle.join(' '))}>
          {title && (
            <h1 className='d-flex align-items-center text-dark fw-bolder my-1 fs-3 text-capitalize'>
              {icon && <i className={clsx('me-2 fs-1 text-primary bi', icon)}></i>} {title}
            </h1>
          )}
        </div>
        <div className='d-flex align-items-center py-1'>{children}</div>
      </div>
    </div>
  );
};

export default Toolbar;
